import { I as e } from "./icon-C5cGsR9k.js";
const a = {
  label: {
    type: String,
    default: ""
  },
  sharedStyles: {
    type: Object,
    default: () => ({})
  },
  isDark: {
    type: Boolean,
    default: !1
  },
  hasBorder: {
    type: Boolean,
    default: !1
  },
  hasBottomLine: {
    type: Boolean,
    default: !1
  },
  disable: {
    type: Boolean,
    default: !1
  },
  placeholder: {
    type: String,
    default: "Here is placeholder"
  },
  size: {
    type: String,
    default: "normal"
  },
  modelValue: {
    type: [String, Number, Boolean, Array],
    default: ""
  },
  rawValue: {
    type: [String, Number, Boolean],
    default: ""
  },
  enableUpdate: {
    type: Boolean,
    default: !0
  }
}, l = {
  options: {
    type: Array,
    default: () => []
  },
  valueKey: {
    type: String,
    default: "id"
  },
  labelKey: {
    type: String,
    default: "text"
  },
  /**
   * Specifies the maximum number of items that can be selected.
   * @prop {number} selectLimit - The maximum number of items that can be selected.
   *   Use `1` for single selection or `-1` for unlimited selection.
   */
  selectLimit: {
    type: Number,
    default: 1
    // Single Select
  },
  navIcon: {
    type: String,
    default: "ChevronDown"
  },
  prefixIconKey: {
    type: String,
    default: ""
  },
  suffixIconKey: {
    type: String,
    default: ""
  },
  allowSearch: {
    type: Boolean,
    default: !0
  },
  removeSearchIcon: {
    type: String,
    default: `${e.GENERAL}/remove-circle.svg`
  },
  isClearable: {
    type: Boolean,
    default: !0
  },
  clearIcon: {
    type: String,
    default: `${e.GENERAL}/remove-circle.svg`
  },
  emptyText: {
    type: String,
    default: "Not found data"
  },
  disableUnSelectSingleMode: {
    type: Boolean,
    default: !1
  },
  isUsingSearchServer: {
    type: Boolean,
    default: !1
  },
  tooltipDisplay: {
    type: String,
    default: ""
  },
  tooltipDisplayPlacement: {
    type: String,
    default: "right"
  }
}, o = {
  isEnableLoadMore: {
    type: Boolean,
    default: !1
  },
  isEnablePagination: {
    type: Boolean,
    default: !1
  },
  perPage: {
    type: Number,
    default: 5
  }
}, r = {
  type: {
    type: String,
    default: "text"
  },
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 9999999
  },
  autoFocus: {
    type: Boolean,
    default: !0
  },
  value: {
    type: [String, Number],
    default: ""
  },
  modelValue: {
    type: [String, Number],
    default: ""
  },
  regex: {
    type: String,
    default: ""
  }
};
export {
  a as b,
  r as i,
  o as p,
  l as s
};
